import { getAllSlotsInContainer } from './utils';
import { showSlotIfExists, openSlotIfExists } from './showSlotIfExists';
import * as store from './slotOpenerStore';

import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';
import type { DragHandlerHooks } from '#packages/addPanelInfra';

export const createSlotOpenerDragPluginAddPanel = () => {
  return {
    init: (editorAPI: EditorAPI, hooks: DragHandlerHooks) => {
      let prevAttachCandidate: CompRef | null = null;

      hooks.onAttachCandidateFound.tap(({ candidate }) => {
        if (prevAttachCandidate?.id === candidate.id) {
          return;
        }

        prevAttachCandidate = candidate;
        const allSlots = getAllSlotsInContainer(editorAPI, candidate);
        store.setAllSlotsInContainer(allSlots);
      });

      hooks.onDragOutsideAddPanelArea.tap(({ mousePosition }) => {
        showSlotIfExists(editorAPI, mousePosition);
      });

      hooks.onComponentDrop.tap(({ comp }) => {
        if (!comp) {
          return;
        }

        openSlotIfExists(editorAPI, comp);
        prevAttachCandidate = null;
      });
    },
  };
};
